import React from 'react';

import BrowseFilesButton, {FileEvent} from '@components/buttons/BrowseFilesButton';
import FilePreview from '@components/panels/FilePreview/FilePreview';

interface UploadFilePanelProps {
    /**
     * File extensions to allow a User to select.
     * Example: '.pdf, .png'
     */
    allowedTypes?: string;

    /**
     * The currently selected file (controlled component)
     */
    file?: File;

    /**
     * Whether the file input is required for form validation
     */
    required?: boolean;

    /**
     * Test ID for the component
     * When file exists: used for preview (as '{testId}-preview') and re-upload button (as '{testId}-replace')
     * When no file: used for upload button (as '{testId}-upload')
     */
    testId?: string;

    /**
     * Raised when a file is selected or deselected.
     * @param e FileEvent containing file property (either File or undefined)
     */
    onSelect?: (e: FileEvent) => void;
}

export default function UploadFilePanel(props: UploadFilePanelProps) {
    const onSelectHandler = (event: FileEvent) => {
        props.onSelect?.(event);
    };

    return (
        <>
            {props.file ? (
                <>
                    <FilePreview
                        file={props.file}
                        testId={props.testId ? `${props.testId}-preview` : undefined}
                        maxWidth={350}
                        maxHeight={250}
                    />
                    <div style={{ marginTop: '1vh' }}>
                        <BrowseFilesButton
                            allowedTypes={props.allowedTypes}
                            variant='subtle'
                            label='Re-upload image'
                            testId={props.testId ? `${props.testId}-replace` : undefined}
                            onClick={onSelectHandler}
                        />
                    </div>
                </>
            ) : (
                <div style={{ marginTop: '1vh' }}>
                    <BrowseFilesButton
                        allowedTypes={props.allowedTypes}
                        required={props.required}
                        testId={props.testId ? `${props.testId}-upload` : undefined}
                        onClick={onSelectHandler}
                    />
                </div>
            )}
        </>
    );
}
